import { useTranslation } from "react-i18next";
import React from "react";

const Disclaimer = ({ printView = false }) => {
  const { t: t } = useTranslation();

  return (
    <div
      className={
        printView ? "w3-panel" : "w3-panel w3-card-4 disclaimer-background"
      }
    >
      <p className="disclaimer-text">
        {t("drug_disclaimer")} {t("drug_disclaimer_2")} {t("drug_disclaimer_3")}
      </p>
    </div>
  );
};

export default Disclaimer;
